import Vue from 'vue'
import axios from "axios"
import { apiUrl,commonParams } from "./config"
import qs from 'qs'

axios.defaults.timeout = 10000

axios.interceptors.request.use((config) => {
    // config.headers = {
    //     'Content-Type':'application/x-www-form-urlencoded'
    // }
    if(config.method === 'post') {
        config.data = qs.stringify(config.data)
    }
    return config
}, (error) =>{
    return Promise.reject(error)
})

// axios.interceptors.response.use((response)=> {
//     return response
//   }, (error)=>{
//     return Promise.reject(error.response.data)
// })

// 获取历年真题列表
export function getPaperList(proId,index) {
    const url = apiUrl + "/Index/getPaperList"
    const data = Object.assign({},commonParams,{
        "province_id":proId || 0,
        "page":index || 1,
        "limit":15
    })
    return axios.post(url,data).then(res => {
        return Promise.resolve(res.data)
    }).catch(err => {
        return Promise.reject(err)
    })
}

// 获取历年真题分类(省份)
// export function getProvice() {
//     const url = apiUrl + "/Index/getProvice"
//     return axios.get(url).then(res => {
//         return Promise.resolve(res.data)
//     })
// }

export function getProvice() {
      const url = apiUrl + "/Index/getProvice"
      const data = {"limit":15}
      return axios.post(url,data).then(res => {
          return Promise.resolve(res.data)
      }).catch(err => {
          return Promise.reject(err)
      })
  }

// 搜索历年真题试卷
export function searchPaperList(keyword,page) {
    const url = apiUrl + "/Index/searchPaperList"
    const data = Object.assign({},commonParams,{
        "keyword":keyword,
        "page":page || 1,
        "limit":15
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}

// 申请试卷
export function applyPaper(id,type,number,rank,aid) {
    const url = apiUrl + "/Paper/applyPaper"
    const data = Object.assign({},commonParams,{
        "item_id":id,
        "apply_type":type,
        "apply_client":1,
        "q_nums":number || 0,
        "rank":rank || 0,
        "attr_id":aid || 0
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}

// 加载试卷
export function loadPaper(id) {
    const url = apiUrl + "/Paper/loadPaper"
    const data = Object.assign({},commonParams,{
        "upaper_id":id
    })
    return axios.post(url,data).then(res => {
        return Promise.resolve(res.data)
    })
}

// 定时保存
export function savePaper(id,items,time,type) {
    const url = apiUrl + "/Paper/loopSavePaper"
    const data = Object.assign({},commonParams,{
        "upaper_id":id,
        "items":items,
        "use_time":time,
        "apply_type":type,
        "apply_client":1
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}

// 交卷
export function assignPaper(id,type) {
    const url = apiUrl + "/Paper/submitPaper"
    const data = Object.assign({},commonParams,{
        "upaper_id":id,
        "apply_type":type
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}


// 获取模块练习分类列表
export function getCateTree() {
    const url = apiUrl + "/Index/getCateTree"
    const data = Object.assign({},commonParams,{})
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}

// 难度突破列表
export function getDiffTree() {
    const url = apiUrl + "/Index/getDiffTree"
    const data = Object.assign({},commonParams,{})
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}

// 十分钟速练分类
export function getTenCate() {
    const url = apiUrl + "/Index/getSecondCateList"
    return axios.get(url).then(res => {
        return Promise.resolve(res.data)
    }).catch(err => {
        return Promise.reject(err)
    })
}

// 十分钟速练列表
export function getTenPaper(id,page) {
    const url = apiUrl + "/Index/getTenPaperList"
    const data = Object.assign({},commonParams,{
        "cate_id":id || 0,
        "page":page || 1,
        "limit":15
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    }).catch(err => {
        return Promise.reject(err)
    })
}

// 五策训练列表
export function getFivePaper(page) {
    const url = apiUrl + "/Index/getFivePaperList"
    const data = Object.assign({},commonParams,{
        "page":page || 1,
        "limit":10
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}

export function getTeacherPapers(page){
    const url = apiUrl + "/Index/getVipPaperList"
    const data = Object.assign({},commonParams,{
        "page":page || 1,
        "limit":10
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}

// VIP检测
export function isVip() {
    const url = apiUrl + "/Index/isLyVip"
    const data = Object.assign({},commonParams,{})
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}

// 用户试卷列表
export function getUserPaper(state,page) {
    const url = apiUrl + "/Index/getCompletePaperLog"
    const data = Object.assign({},commonParams,{
        "state":state || 0,
        "page":page || 1,
        "limit":15
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}

// 错题集
export function getErrPaper() {
    const url = apiUrl + "/Index/getErrTree"
    const data = Object.assign({},commonParams,{})
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}

// 查看错题
export function loadError(rank,id,page) {
    const url = apiUrl + "/Index/loadErr"
    const data = Object.assign({},commonParams,{
        "rank":rank,
        "cate_id":id,
        "page":page || 1,
        "limit":10
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}
// 获取错题数
export function getErrorNum(){
    const url = apiUrl + "/Index/getErrNum"
    const data = Object.assign({},commonParams,{})
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}
// 删除错题
export function deleteErr(qid){
    const url = apiUrl + '/Index/removeErr'
    const data = Object.assign({},commonParams,{
        "qid":qid
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}
// 搜索错题
export function searchUserPaper(keyword,page){
    const url = apiUrl + "/Index/searchUserPaperList"
    const data = Object.assign({},commonParams,{
        "keyword":keyword,
        "page":page || 1,
        "limit":15
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}
// 退出登录
export function uloginOut(){
    const url = apiUrl + "/Index/loginout"
    return axios.get(url).then(res => {
        return Promise.resolve(res.data)
    })
}
// 下载试卷
export function downPaper(pid){
    const url = apiUrl + '/Index/download'
    const data = Object.assign({},commonParams,{
        "paper_id":pid
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}
// 下载动态试卷
export function downDynamicPaper(pid){
    const url = apiUrl + '/Index/downloadDynamicPaper'
    const data = Object.assign({},commonParams,{
        "upaper_id":pid
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}
// 行测模考
export function mockPaper(year,page){
    const url = apiUrl + "/Index/getMockPaperList"
    const data = Object.assign({},commonParams,{
        "year":year || 0,
        "page":page || 1,
        "limit":15
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}
// 行测模考 年份
export function mockYear(){
    const url = apiUrl + "/Index/getYear"
    return axios.get(url).then(res => {
        return Promise.resolve(res.data)
    })
}
// 加载模考报告
export function loadMockReport(mid){
    const url = apiUrl + "/Paper/loadMockReport"
    const data = Object.assign({},commonParams,{
        "mock_id":mid
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}
// 直播报名
export function signLiveTo(vid){
    const url = apiUrl + "/Index/signLive"
    const data = Object.assign({},commonParams,{
        "live_id":vid
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}
// 加载体验模考报告
export function loadPracticeMock(id){
    const url = apiUrl + "/Paper/loadTiyanMockReport"
    const data = Object.assign({},commonParams,{
        "upaper_id":id
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}
// 获取行测估分列表
export function gufenPaper(page){
    const url = apiUrl + "/Index/getGufen"
    const data = Object.assign({},commonParams,{
        "page":page || 1,
        "limit":15
    })
    return axios.post(url, data).then(res => {
        return Promise.resolve(res.data)
    })
}





// WEBPACK FOOTER //
// ./src/assets/api/list.js